import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconMoon = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 22 22"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <mask id="mask0_9684_54285" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
          <rect width="24" height="24" fill="currentColor" />
        </mask>
        <path
          d="M12.1 22C10.7 22 9.3875 21.7333 8.1625 21.2C6.9375 20.6667 5.87083 19.9458 4.9625 19.0375C4.05417 18.1292 3.33333 17.0625 2.8 15.8375C2.26667 14.6125 2 13.3 2 11.9C2 9.46667 2.775 7.32083 4.325 5.4625C5.875 3.60417 7.85 2.45 10.25 2C9.95 3.65 10.0417 5.2625 10.525 6.8375C11.0083 8.4125 11.8417 9.79167 13.025 10.975C14.2083 12.1583 15.5875 12.9917 17.1625 13.475C18.7375 13.9583 20.35 14.05 22 13.75C21.5667 16.15 20.4167 18.125 18.55 19.675C16.6833 21.225 14.5333 22 12.1 22ZM12.1 20C13.5667 20 14.925 19.6333 16.175 18.9C17.425 18.1667 18.4083 17.1583 19.125 15.875C17.6917 15.7417 16.3333 15.3792 15.05 14.7875C13.7667 14.1958 12.6167 13.3917 11.6 12.375C10.5833 11.3583 9.775 10.2083 9.175 8.925C8.575 7.64167 8.21667 6.28333 8.1 4.85C6.81667 5.56667 5.8125 6.55417 5.0875 7.8125C4.3625 9.07083 4 10.4333 4 11.9C4 14.15 4.7875 16.0625 6.3625 17.6375C7.9375 19.2125 9.85 20 12.1 20Z"
          fill="currentColor"
        />
      </svg>
    );
  }
);
